import { Reducer } from 'redux';
import { Model } from 'services/model/model.type';
import { ModelActionTypes } from 'types/actions/model';

import { modelConstant } from '../actionTypes';

interface ModelState {
  models: Model[];
  isLoading: boolean;
  error: Error | null;
}

const initialState: ModelState = {
  models: [],
  isLoading: false,
  error: null,
};

const modelReducer: Reducer<ModelState, ModelActionTypes> = (
  state = initialState,
  action: ModelActionTypes
) => {
  switch (action.type) {
    case modelConstant.FETCH_MODELS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case modelConstant.FETCH_MODELS_SUCCESS:
      return {
        ...state,
        models: action.payload,
        isLoading: false,
        error: null,
      };
    case modelConstant.FETCH_MODELS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default modelReducer;
